import Request from '../core/utils/Request';

const API = {
  getAreas(customer_id = 2135) {
    return Request.get(`/instant-quote/body-areas?customer_id=${customer_id}`);
  },
  getPrices(data) {
    return Request.post('instant-quote/price', data);
  },
  postLead(data) {
    return Request.post('instant-quote/lead', data);
  },
};

export default API;
